import transform from 'lodash/transform';
import { black, blue, green, grey, red, white, yellow } from 'shared/constants/colors'; // TODO: заменить переенными uikit

const map2CssVars = (prefix: string, object: object) =>
  transform(
    object,
    (result, value, key) => {
      const newKey = `--dion-${prefix}-${key as string}`;

      result[newKey] = value;
    },
    {}
  );

export const GLOBAL_STYLES = {
  ':root': {
    ...map2CssVars('red', red), // TODO: заменить переенными uikit
    ...map2CssVars('green', green), // TODO: заменить переенными uikit
    ...map2CssVars('blue', blue), // TODO: заменить переенными uikit
    ...map2CssVars('grey', grey), // TODO: заменить переенными uikit
    ...map2CssVars('yellow', yellow), // TODO: заменить переенными uikit
    ...map2CssVars('black', black), // TODO: заменить переенными uikit
    ...map2CssVars('white', white), // TODO: заменить переенными uikit
    '--smooth-transition': '.27s',
    '--color-light-transparent': 'rgba(255, 255, 255, 0.2)' // TODO: заменить переенными uikit
  },
  html: {
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale'
  },
  body: {
    display: 'flex',
    flex: '1 0 100%',
    flexDirection: 'column',
    margin: '0',
    minHeight: 'inherit',
    paddingBottom: 'env(safe-area-inset-bottom)',
    overscrollBehaviorX: 'none' // отключим переход по истории браузера назад-вперед свайпом двумя пальцами по тачпаду
  },
  '#root': {
    display: 'flex',
    flexDirection: 'column',
    minHeight: 'inherit',
    flex: '1 0 100%'
  }
};

// export const inputGlobalStyles = <GlobalStyles styles={GLOBAL_STYLES} />
